import clsx from 'clsx'
import Logo from 'common/components/Logo'
import {useMediaQuery} from 'common/hooks/useMediaQuery'
import {Link} from 'react-router'

import {KTIcon} from '_metronic/helpers'
import {LayoutSetup, useLayout} from '_metronic/layout/core'

import {Header} from './Header'
import {Navbar} from './Navbar'
import StudentHouseBadge from './StudentHouseBadge'
import {DESKTOP_MEDIA_QUERY} from './breakpoints'

export function HeaderWrapper() {
  const {config, classes} = useLayout()
  // Below lg the header strip (branch select, support link) lives in the
  // profile menu; not mounting it here keeps the branch list to one fetch.
  const isDesktop = useMediaQuery(DESKTOP_MEDIA_QUERY)
  if (config.app?.header?.default?.container === 'fluid') {
    LayoutSetup.classes.headerContainer.push('container-fluid')
  } else {
    LayoutSetup.classes.headerContainer.push('container-xxl')
  }
  if (!config.app?.header?.display) {
    return null
  }

  return (
    <div
      id='kt_app_header'
      className='app-header header-with-alert'
      data-kt-sticky='true'
      data-kt-sticky-activate='{default: true, lg: true}'
      data-kt-sticky-name='app-header-minimize'
      data-kt-sticky-offset='{default: "200px", lg: "0"}'
      data-kt-sticky-animation='false'
    >
      <div
        id='kt_app_header_container'
        className={clsx(
          'app-container',
          classes.headerContainer.join(' '),
          config.app?.header?.default?.containerClass
        )}
      >
        {config.app.sidebar?.display && (
          <>
            {config.layoutType !== 'dark-header' && config.layoutType !== 'light-header' ? (
              <div
                className='d-flex align-items-center d-lg-none ms-n2 me-2'
                title='Show sidebar menu'
              >
                <div
                  className='btn btn-icon btn-active-color-primary w-35px h-35px'
                  id='kt_app_sidebar_mobile_toggle'
                >
                  <KTIcon iconName='abstract-14' className=' fs-1' />
                </div>
                <div className='d-flex align-items-center flex-grow-1 flex-lg-grow-0 app-header-mobile-logo'>
                  <Link to='/dashboard' className='d-lg-none'>
                    {/* <img
                      alt='Logo'
                      src={toAbsoluteUrl('media/logos/default-small.svg')}
                      className='h-30px'
                    /> */}
                    <Logo size='small' />
                  </Link>
                </div>
              </div>
            ) : null}
          </>
        )}

        {!(config.layoutType === 'dark-sidebar' || config.layoutType === 'light-sidebar') && (
          <div className='d-flex align-items-center flex-grow-1 flex-lg-grow-0 me-lg-15'>
            <Link to='/dashboard'>
              {/* {config.layoutType === 'dark-header' ? (
                <img
                  alt='Logo'
                  src={toAbsoluteUrl('media/logos/default-dark.svg')}
                  className='h-20px h-lg-30px app-sidebar-logo-default'
                />
              ) : (
                <>
                  <img
                    alt='Logo'
                    src={toAbsoluteUrl('media/logos/default.svg')}
                    className='h-20px h-lg-30px app-sidebar-logo-default theme-light-show'
                  />
                  <img
                    alt='Logo'
                    src={toAbsoluteUrl('media/logos/default-dark.svg')}
                    className='h-20px h-lg-30px app-sidebar-logo-default theme-dark-show'
                  />
                </>
              )} */}
              <Logo size='small' />
            </Link>
          </div>
        )}

        <div
          id='kt_app_header_wrapper'
          className='d-flex align-items-stretch justify-content-between flex-lg-grow-1'
        >
          {/* The student's house in its label colour, at the start of the
              header beside the sidebar toggle. Below `lg` Navbar shows it
              among the right-hand items instead (never both). */}
          {isDesktop && <StudentHouseBadge className='d-flex align-items-center me-4' />}
          {isDesktop &&
            config.app.header.default?.content === 'menu' &&
            config.app.header.default.menu?.display && (
              <div
                id='kt_app_header_menu_wrapper'
                // d-flex: without it the 44px menu row sits at the top of the
                // 74px header and the leftover reads as a gap above the title.
                className='app-header-menu d-flex align-items-stretch flex-lg-fill'
              >
                <Header />
              </div>
            )}
          <Navbar />
        </div>
      </div>
    </div>
  )
}
